import React, { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "@nextui-org/react";

import { NumericFormat } from "react-number-format";

// import { render } from "@react-email/render";
// import nodemailer from "nodemailer";

// const transporter = nodemailer.createTransport({
//   host: "smtp.gmail.com",
//   port: 465,
//   secure: true,
//   auth: {
//     user: "tajbsta22@gmail.com",
//     pass: "yidp lshb foqn axlb",
//   },
// });

function HelpPopup(props) {
  const [insuranceGoal, setInsuranceGoal] = useState(props.defaultInsuranceGoal);
  const [investmentGoal, setInvestmentGoal] = useState(props.defaultInvestmentGoal);
  const [averageCaseSize, setAverageCaseSize] = useState(props.defaultAverageCaseSize);
  const [saving, setSaving] = useState(false);

  const inputCleanAndValidate = (input) => {
    if (input < 0) {
      return 0;
    }

    return Math.round(input);
  };

  const saveCallback = (status) => {
    if (status == "ERROR") {
      setSaving(false);
    } else {
      setSaving(false);
      handleClose();
    }
  };

  const onSave = async () => {
    // setSaving(true);
    // // const emailHtml = render(<Email url="https://example.com" />);
    // const options = {
    //   from: "tajbsta22@gmail.com",
    //   to: "tajbsta22@gmail.com",
    //   subject: "hello world",
    //   html: "hello world",
    // };
    // await transporter.sendMail(options);
    // setSaving(false);
  };

  const handleClose = () => {
    props.handleClose();
  };

  const onOpenChange = (isOpen) => {
    if (!isOpen) {
      handleClose();
    }
  };

  return (
    <Modal isOpen={props.open} onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 text-center text-2xl font-bold text-[#002e62]">
              Help
            </ModalHeader>
            <ModalBody>
              <div>
                <NumericFormat
                  customInput={Input}
                  label="Yearly Insurance Income Goal"
                  value={insuranceGoal}
                  onValueChange={(values) => setInsuranceGoal(values.value)}
                  thousandSeparator
                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-default-400 text-small">$</span>
                    </div>
                  }
                  className="px-2"
                />
              </div>
            </ModalBody>
            <ModalFooter className="flex justify-center">
              <Button color="primary" isLoading={saving} onPress={onSave}>
                Submit
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}

export default HelpPopup;
